import styled, { keyframes, css } from 'styled-components';
import { ClassNameInjector } from './ClassNameInjector.js';

const fadeInAnimation = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
const fadeOutAnimation = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;
const FadeInOutAnimation = styled(ClassNameInjector).withConfig({
    displayName: "FadeInOut.styles__FadeInOutAnimation",
    componentId: "sc-e22f4b1f-0"
})(({ active , animationDurationInMs  })=>{
    if (active) {
        return css`
            animation-name: ${fadeInAnimation};
            animation-timing-function: ${"ease-in"};
            animation-duration: ${animationDurationInMs}ms;
        `;
    } else {
        return css`
            animation-name: ${fadeOutAnimation};
            animation-timing-function: ${"ease-out"};
            animation-duration: ${animationDurationInMs}ms;
        `;
    }
});

export { FadeInOutAnimation };
